// src/api/styleTemplatesApi.js
// Cliente del backend de plantillas de estilo (editor /estilos, F3).
// Envia el grant de acceso (x-styles-grant) en cada peticion: el backend valida
// ese grant (no el correo de la cuenta) para autorizar.
import { ENV } from "../Utils";
import { getStylesGrant } from "../store/stylesAccessStore";

export class StyleTemplatesApi {
  baseApi = ENV.BASE_API;

  headers(token, withJson = false) {
    const h = {
      Authorization: `Bearer ${token}`,
      "x-styles-grant": getStylesGrant(),
    };
    if (withJson) h["Content-Type"] = "application/json";
    return h;
  }

  async list(token, status) {
    const q = status ? `?status=${encodeURIComponent(status)}` : "";
    const res = await fetch(`${this.baseApi}/style-templates${q}`, {
      headers: this.headers(token),
    });
    const json = await res.json();
    if (res.status !== 200) throw json;
    return json.data; // { docs, totalDocs, page, totalPages }
  }

  async get(token, id) {
    const res = await fetch(`${this.baseApi}/style-templates/${id}`, {
      headers: this.headers(token),
    });
    const json = await res.json();
    if (res.status !== 200) throw json;
    return json.data;
  }

  async create(token, payload) {
    const res = await fetch(`${this.baseApi}/style-templates`, {
      method: "POST",
      headers: this.headers(token, true),
      body: JSON.stringify(payload),
    });
    const json = await res.json();
    if (res.status !== 201) throw json;
    return json.data;
  }

  async update(token, id, payload) {
    const res = await fetch(`${this.baseApi}/style-templates/${id}`, {
      method: "PUT",
      headers: this.headers(token, true),
      body: JSON.stringify(payload),
    });
    const json = await res.json();
    if (res.status !== 200) throw json;
    return json.data;
  }

  async approve(token, id) {
    const res = await fetch(`${this.baseApi}/style-templates/${id}/approve`, {
      method: "POST",
      headers: this.headers(token),
    });
    const json = await res.json();
    if (res.status !== 200) throw json;
    return json.data;
  }

  async remove(token, id) {
    const res = await fetch(`${this.baseApi}/style-templates/${id}`, {
      method: "DELETE",
      headers: this.headers(token),
    });
    const json = await res.json();
    if (res.status !== 200) throw json;
    return json;
  }
}

export default StyleTemplatesApi;
